import { useEffect, useRef } from "react";
import { Crown, Medal, Award } from "lucide-react";
import { API } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

const BADGES = {
  top1: { Icon: Crown, c: "#ffc94d", bg: "from-[#ffc94d]/30 to-[#ff8a00]/20" },
  top3: { Icon: Medal, c: "#c79bff", bg: "from-[#a746ff]/30 to-[#2f7bff]/20" },
  top10: { Icon: Award, c: "#3ad7ff", bg: "from-[#3ad7ff]/25 to-[#2f7bff]/15" },
};

export const RankBadge = ({ badge, testid = "rank-badge" }) => {
  const { t } = useI18n();
  const b = BADGES[badge];
  if (!b) return null;
  const { Icon } = b;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border border-white/15 bg-gradient-to-r ${b.bg} backdrop-blur px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider`}
      style={{ color: b.c }} data-testid={testid} data-badge={badge}>
      <Icon className="w-3 h-3" />{t(`lb.badge_${badge}`)}
    </span>
  );
};

const usePlayWhenVisible = () => {
  const ref = useRef(null);
  useEffect(() => {
    const v = ref.current;
    if (!v || !("IntersectionObserver" in window)) return undefined;
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) v.play().catch(() => {}); else v.pause(); }, { threshold: 0.4 });
    io.observe(v);
    return () => io.disconnect();
  }, []);
  return ref;
};

export const FitVideo = ({ sid, aspect, testid }) => {
  const ref = usePlayWhenVisible();
  const src = `${API}/s/${sid}/video.mp4`;
  const poster = `${API}/s/${sid}/thumb.jpg`;
  if (aspect === "9:16") {
    return <video ref={ref} src={src} poster={poster} muted loop playsInline preload="none" className="absolute inset-0 w-full h-full object-cover" data-testid={testid} />;
  }
  return (
    <>
      <img src={poster} alt="" aria-hidden className="absolute inset-0 w-full h-full object-cover scale-125 blur-2xl opacity-70" />
      <div className="absolute inset-0 bg-black/30" />
      <video ref={ref} src={src} poster={poster} muted loop playsInline preload="none"
        className="absolute inset-x-0 top-1/2 -translate-y-1/2 w-full object-contain shadow-[0_20px_50px_rgba(0,0,0,0.7)]" data-testid={testid} />
    </>
  );
};
